import { Card, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { FlagIcon, Icons } from "../../../Constant";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { FlagIconCardBody } from "./FlagIconCardBody";
import { useState } from "react";
import IconMarkUp from "../Icon-markup";

const FlagIconsContainer = () => {
  const [iTag, setiTag] = useState<string | object>("");
  const [icon, setIcon] = useState<string | object>("");
  
  return (
    <>
      <Breadcrumbs pageTitle={FlagIcon} parent={Icons} title={FlagIcon} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={FlagIcon} />
              <FlagIconCardBody setiTag={setiTag} setIcon={setIcon}  />
            </Card>
          </Col>
        </Row>
      </Container>
      <IconMarkUp itag={iTag} icons={icon}/>
    </>
  );
};

export default FlagIconsContainer;
